<script lang="ts">
    export let label_text = "";
    export let label_for = "";
</script>

<label for={label_for}>{label_text}</label>